import { Flex, FlexProps, useColorModeValue } from "@chakra-ui/react"
import SearchFilters from "@components/Search/Filters/SearchFilters"
import SearchBar from "@components/Search/SearchBar"
import useStickySearch from "@hooks/useStickySearch"
import { useRef } from "react"

const SearchBox = (props: FlexProps) => {
  const searchBgColor = useColorModeValue("white", "black")
  const searchBarRef = useRef<HTMLDivElement>(null)
  useStickySearch(searchBarRef, true)
  return (
    <Flex
      ref={searchBarRef}
      flexDirection={"column"}
      w={"full"}
      bgColor={searchBgColor}
      zIndex={10}
      top={0}
      left={0}
      right={0}
      p={4}
      shadow={"md"}
      transition={"all 0.3s ease-in-out"}
      overflow={"hidden"}
      {...props}
    >
      <SearchBar />
      <SearchFilters />
    </Flex>
  )
}

export default SearchBox
